<div class="wrapper">
  <app-header></app-header>

  <div class="container">
    <div class="h-100 p-relative overflow-auto">
      <div class="px-3 py-2 overflow-scroll">
        <div *ngIf="step?.showIntro">
          <h1 style="font-size: 24px" class="text-black">
            {{ translations['fix_label'] }}
          </h1>
          <p>{{ translations['info_text'] }}</p>
          <p>{{ translations['step_message'] }}</p>
        </div>

        <div *ngIf="!step?.showIntro">
          <div *ngIf="step?.steps" class="show-intro">
            {{ step?.steps[0]?.label[languageIndex] }}
          </div>
        </div>

        <div *ngIf="step?.machineIssueListItems">
          <div class="progress-container">
            <div class="progress-bar">
              <div
                *ngFor="let item of machineIssueList"
                class="progress-fill"
                [style.width.%]="progress"
                [ngClass]="{ inactive: !item.answered }"
              ></div>
            </div>
            <div class="progress-segment">
              {{ progress | number: '1.0-0' }}%
            </div>
          </div>
          <div *ngIf="machineIssueList.length > 0">
            <h4 class="show-intro">{{ translations['check_machine'] }}</h4>
            <div
              *ngFor="let question of step.machineIssueListItems; let i = index"
              class="check-item"
            >
              <div class="result-content">
                <div class="sub-content">
                  <div
                    class="status-indicator"
                    *ngIf="!question.answered; else answeredTemplate"
                  >
                    <div class="circle"></div>
                  </div>
                  <ng-template #answeredTemplate>
                    <div class="ticks"><i class="fas fa-check"></i></div>
                  </ng-template>
                  <div class="content-list">
                    {{ getTranslatedTitle(question) }}
                  </div>
                </div>
                <div
                  *ngIf="
                    (question.details &&
                      languageDetails?.(question)?.length > 0) ||
                    (question.details &&
                      question.details.images &&
                      question.details.images.length > 0)
                  "
                  class="accordion-icon"
                  (click)="toggleAccordion(i)"
                >
                  <i
                    [ngClass]="
                      question.expanded
                        ? 'fas fa-chevron-up'
                        : 'fas fa-chevron-down'
                    "
                  ></i>
                </div>
              </div>
              <div class="accordion-content" *ngIf="question.expanded">
                <div *ngFor="let details of languageDetails?.(question)">
                  <p>{{ details }}</p>
                </div>
                <div
                  *ngIf="
                    (question?.details?.images?.length &&
                      !(
                        question.keyValue === 3 ||
                        question.keyValue === 8 ||
                        question.keyValue === 9
                      )) ||
                    question.keyValue === 1 ||
                    question.keyValue === 2 ||
                    question.keyValue === 4 ||
                    question.keyValue === 5 ||
                    question.keyValue === 6 ||
                    question.keyValue === 7 ||
                    question.keyValue === 10 ||
                    question.keyValue === 11 ||
                    question.keyValue === 12 ||
                    question.keyValue === 13 ||
                    question.keyValue === 14
                  "
                >
                  <img
                    class="img-thumbnail"
                    [src]="question.details.images[0].url"
                    [alt]="question.details.images[0].alt"
                    (click)="openImagesPopup(question)"
                  />
                </div>

                <div
                  class="accordion-img"
                  *ngIf="
                    (question?.details?.images?.length &&
                      question.keyValue === 3) ||
                    question.keyValue === 8 ||
                    question.keyValue === 9 ||
                    !(
                      question.keyValue === 1 ||
                      question.keyValue === 2 ||
                      question.keyValue === 4 ||
                      question.keyValue === 5 ||
                      question.keyValue === 6 ||
                      question.keyValue === 7 ||
                      question.keyValue === 10 ||
                      question.keyValue === 11 ||
                      question.keyValue === 12 ||
                      question.keyValue === 13 ||
                      question.keyValue === 14
                    )
                  "
                >
                  <div *ngFor="let image of question.details.images">
                    <img
                      class="img-thumbnails p-1"
                      [src]="image.url"
                      [alt]="image.alt"
                      (click)="openImagesPopup(question)"
                    />
                  </div>
                </div>
              </div>
              <div class="actions">
                <button
                  class="ok-btn"
                  [class.selectedOk]="question.status === 'ok'"
                  [class.inactive]="question.status === 'issue'"
                  (click)="answer(i, 'ok'); question.expanded = false"
                >
                  <div *ngIf="question.status === 'ok'" class="tick">
                    <i class="fas fa-check"></i>
                  </div>
                  <div>{{ translations['ok'] }}</div>
                </button>

                <button
                  class="issue-btn"
                  [class.selectedIssue]="question.status === 'issue'"
                  [class.inactive]="question.status === 'ok'"
                  (click)="answer(i, 'issue'); question.expanded = false"
                >
                  <div *ngIf="question.status === 'issue'" class="tick-issue">
                    <i class="fas fa-check"></i>
                  </div>
                  <div>{{ translations['issue'] }}</div>
                </button>
              </div>
            </div>
          </div>
          <div class="button-group">
            <button class="help-btn" (click)="resolved()">
              {{ translations['resolved'] }}
            </button>
            <button class="btn-blue-outline ms-1" (click)="needHelp()">
              <img class="chatIcon" src="assets/images/icon/chat.png" />
              <span> {{ translations['need_help'] }}</span>
            </button>
          </div>
        </div>

        <div *ngFor="let step of step?.steps">
          <div *ngIf="step?.description?.length">
            <p class="img-desc">{{ step?.description[languageIndex] }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="footer">
    <div
      *ngIf="step?.steps"
      style="display: flex; justify-content: space-evenly"
    >
      <ul
        style="list-style-type: none; padding: 0; margin: 0"
        *ngFor="let option of step?.steps[0]?.options"
      >
        <li
          *ngIf="option?.icon == 'check' && !(option?.label == 'Start')"
          class="text-center"
        >
          <div
            class="button2"
            style="background-color: #00a653"
            (click)="selection(option)"
          >
            <span style="fill: white">
              <img class="yes-icon" src="assets/images/icon/yes.png" />
            </span>
          </div>
          <span class="fw-semibold">
            {{ option?.label[languageIndex] }}
          </span>
        </li>

        <li
          class="button"
          *ngIf="option?.icon == 'check' && option?.label == 'Start'"
          (click)="start(option)"
          class="text-center"
        >
          <span>
            {{ option?.label[languageIndex] }}
          </span>
        </li>

        <li *ngIf="option?.icon == 'question'" class="text-center">
          <div class="mb-3 mt-3">
            <span
              class="button3"
              style="fill: #ffffff"
              style="background-color: #f5af00"
              (click)="requestHelp(option)"
            >
              <img style="width: 25px" src="assets/images/icon/question.png" />
            </span>
          </div>
          <span class="fw-semibold">
            {{ option?.label[languageIndex] }}
          </span>
        </li>

        <li *ngIf="option?.icon == 'cross'" class="text-center">
          <div
            class="button2"
            (click)="selection(option)"
            style="background-color: #cc3300"
          >
            <span style="fill: #006bd3">
              <img style="width: 25px" src="assets/images/icon/no.png" />
            </span>
          </div>
          <span class="fw-semibold">
            {{ option?.label[languageIndex] }}
          </span>
        </li>
      </ul>
    </div>

    <div *ngIf="!step?.steps" style="display: flex; gap: 0.5rem">
      <ul
        style="list-style-type: none; padding: 0; margin: 0; width: 100%"
        *ngFor="let option of step?.options"
      >
        <li
          class="button"
          *ngIf="
            option?.icon == 'check' &&
            (option?.label[languageIndex] == 'Start' ||
              option?.label[languageIndex] == 'Comenzar')
          "
          (click)="start(option)"
        >
          {{ option?.label[languageIndex] }}
        </li>

        <li
          class="button"
          *ngIf="
            option?.icon == 'check' &&
            option?.option == 'troubleshooting.resolved'
          "
          (click)="resolved()"
        >
          {{ option?.label[languageIndex] }}
        </li>

        <li
          class="button"
          *ngIf="option?.icon == 'truck'"
          (click)="requestHelp(option)"
        >
          {{ translations['help_button'] }}
        </li>
      </ul>
    </div>
  </div>

  <div class="popup" *ngIf="popupDetails?.showPopup">
    <div class="image-container">
      <div class="popup-container">
        <div class="do-container">
          <div class="flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="black"
              viewBox="0 0 24 24"
            >
              <path
                d="M20.285 6.709a1 1 0 00-1.414 0L9 16.58l-4.871-4.87a1 1 0 00-1.414 1.415l5.577 5.576a1 1 0 001.414 0l10.283-10.283a1 1 0 000-1.414z"
              />
            </svg>
            <span>{{ translations['do'] }}</span>
          </div>
          <div class="flex">
            <div class="close-icon" (click)="closePopup()">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="white"
                viewBox="0 0 24 24"
              >
                <path
                  d="M6 6L18 18M6 18L18 6"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            </div>
          </div>
        </div>

        <div class="flex drain-content" *ngIf="currentQuestion?.keyValue === 8">
          <div
            class="images-wrapper"
            style="
              position: relative;
              align-items: center;
              justify-content: center;
            "
          >
            <button
              *ngIf="popupImageIndex > 0"
              (click)="onPreviousImages()"
              class="nav-btn left"
            >
              <img
                class="arrow-img"
                src="./assets/images/icon/arrow-left.png"
              />
            </button>

            <div class="images">
              <div *ngFor="let img of currentImages">
                <img [src]="img.url" [alt]="img.alt" class="img-section" />
              </div>
            </div>

            <button
              *ngIf="popupImageIndex + 2 < (popupDetails.images?.length || 0)"
              (click)="onNextImages()"
              class="nav-btn right"
            >
              <img
                class="arrow-img"
                src="./assets/images/icon/arrow-right.png"
              />
            </button>
          </div>
          <div *ngIf="popupImageIndex === 0" class="overlay-text-1">
            {{ translations['drain_intake'] }}
          </div>
          <div *ngIf="popupImageIndex === 0" class="overlay-text-2">
            {{ translations['scrap_screens'] }}
          </div>
          <div *ngIf="popupImageIndex === 2" class="img-overlay-text-2">
            {{ translations['float_switch'] }}
          </div>
        </div>

        <div *ngIf="currentQuestion?.keyValue === 2" class="img-overlay-text">
          <div>
            {{ translations['detail'] }}
          </div>
          <div>
            {{ translations['image_detail'] }}
          </div>
        </div>

        <div class="flex" *ngIf="!(currentQuestion?.keyValue === 8)">
          <div *ngIf="popupDetails.images[0]">
            <img
              [src]="popupDetails.images[0].url"
              [alt]="popupDetails.images[0].alt"
              class="img-section"
            />
          </div>

          <div *ngIf="popupDetails.images[1]" class="img-wrapper">
            <img
              [src]="popupDetails.images[1].url"
              [alt]="popupDetails.images[1].alt"
              class="img-section"
            />
          </div>
          <div
            *ngIf="
              currentQuestion?.keyValue === 7 ||
              currentQuestion?.keyValue === 1 ||
              currentQuestion?.keyValue === 6
            "
            class="dont-container"
          >
            <div class="flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="black"
              >
                <path
                  d="M18.3 5.71a1 1 0 00-1.41 0L12 10.59 7.11 5.7A1 1 0 105.7 7.11L10.59 12l-4.89 4.89a1 1 0 101.41 1.41L12 13.41l4.89 4.89a1 1 0 001.41-1.41L13.41 12l4.89-4.89a1 1 0 000-1.4z"
                />
              </svg>
              <span>{{ translations['do_not'] }}</span>
            </div>
          </div>
          <div
            *ngIf="
              currentQuestion?.keyValue === 3 || currentQuestion?.keyValue === 4
            "
            class="img-overlay-text-1"
          >
            {{ translations['top'] }}
          </div>
          <div
            *ngIf="
              currentQuestion?.keyValue === 3 || currentQuestion?.keyValue === 4
            "
            class="img-overlay-text-2"
          >
            {{ translations['bottom'] }}
          </div>
          <div
            *ngIf="
              currentQuestion?.keyValue === 10 ||
              currentQuestion?.keyValue === 11
            "
            class="img-overlay-text-2"
          >
            {{ translations['float_switch'] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
